import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PebbleSpinner } from 'components';
import styled, { css, keyframes } from 'styled-components';
import { purpurColorFunctionalWhite, purpurColorGray100, purpurColorPurple400, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import { purpurShadowMd } from '@purpurds/tokens/shadow/variables';
import spacing from 'theme/spacing';
const fadeOutBorder = keyframes `
  0% {
    border: 1px solid ${purpurColorPurple400};
  }
  100% {
    border: 1px solid ${purpurColorFunctionalWhite};
  }
`;
const ListItemContainer = styled.div `
  box-shadow: ${purpurShadowMd};
  background-color: ${purpurColorFunctionalWhite};
  margin-top: ${spacing.spacing8};
  letter-spacing: -0.5px;
  line-height: normal;
  position: relative;
  padding: 0 ${spacing.spacing8};
  border: 1px solid ${purpurColorGray100};

  ${({ $isFullyRounded }) => $isFullyRounded ?
    css `
      border-radius: 4px;
      z-index: 5;
    ` :
    css `
      border-radius: 4px 4px 0 0;
      border-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.2);
      z-index: 5;
    `}
  
  ${({ $activated }) => $activated &&
    css `  
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      min-height: 55px;
      margin-top: ${spacing.spacing4};
  `}
  
  ${({ $activeBorder }) => $activeBorder
    ? css `
          animation: ${fadeOutBorder} 5s;
        `
    : css `
        border: 1px solid ${purpurColorGray100};
    `}
`;
const ListItemContent = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 55px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
`;
const FetchingOverlay = styled.div `
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  left: 0;
`;
const ErrorMessage = styled.div `
  display: flex;
  align-self: flex-start;
  color: ${purpurColorRed600};
  padding-top: ${spacing.spacing4};
`;
const ListItemButton = styled.button `
  width: 100%;
  border: none;
  background: none;
  padding: 0;
  text-style: none;
  cursor: pointer;
`;
export const ListItem = ({ activated = false, activeBorder = false, isFullyRounded = false, children, isFetching = false, clickable = false, onClick, errorMessage = '', }) => {
    const listItem = (_jsxs(ListItemContainer, { "$isFullyRounded": isFullyRounded, "$activated": activated, "$activeBorder": activeBorder, children: [_jsxs(ListItemContent, { children: [isFetching && (_jsx(FetchingOverlay, { children: _jsx(PebbleSpinner, { size: 36 }) })), children] }), _jsx(ErrorMessage, { children: errorMessage })] }));
    if (clickable) {
        return (_jsx(ListItemButton, { onClick: onClick, children: listItem }));
    }
    return listItem;
};
